import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { ContactContext } from "../../../../context/contact/ContactContext";
import CustomTable from "../Table";
import "../../../../custom.css";
import Wait from "../../../Wait";

const OpenPurchaseOrders = () => {
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(true);
  const { purchaseOrders, getOpenPurchaseOrders } = useContext(ContactContext);

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getOpenPurchaseOrders(1)]);
      setLoading(false);
    };
    fetchData2();
  }, []);
  if (isLoading) {
    return <Wait />;
  }
  return (
    <div className="cssBodyTable">
      <CustomTable data={purchaseOrders} rowsPerPage={30} />
    </div>
  );
};

export default OpenPurchaseOrders;
